import { apiUrl, currentUserId, currentUserQuery } from "./auth";
import type { PipelineStage } from "./suivi";

export type BureauTask = { id: number; title: string; due_on: string; kind: string; fiche_id: number; fiche_name: string };
export type BureauDeal = { fiche_id: number; fiche_name: string; title: string; amount: number; status: string; probability?: number; expected_on?: string };
export type BureauLink = { fiche_id: number; fiche_name: string; company_id: number; client_id: number };
export type BureauQuiet = { id: number; name: string; seen: string };
export type BureauPerson = { id: number; name: string; status: string };
export type Bureau = {
  prospects: number;
  clients: number;
  deals: number;
  pipeline: number;
  relances: number;
  columns: PipelineStage[];
  deals_list: BureauDeal[];
  people: BureauPerson[];
  lanes: { late: BureauTask[]; today: BureauTask[]; week: BureauTask[] };
  quiet?: BureauQuiet[];
  quiet_days?: number;
  links?: BureauLink[];
};

export async function loadBureau(days = 14): Promise<Bureau> {
  const query = currentUserQuery();
  const res = await fetch(`${apiUrl("bureau.php")}${query}${query ? "&" : "?"}days=${days}`, {
    credentials: "include",
    cache: "no-store",
    headers: currentUserId() ? { "X-User-Id": currentUserId() } : {},
  });
  const data = (await res.json().catch(() => ({}))) as { success?: boolean; message?: string; bureau?: Bureau };
  if (!res.ok || data.success === false || !data.bureau) {
    throw new Error(data.message || "Bureau indisponible");
  }
  return data.bureau;
}
